import translations from './translations.json'

export const GetErrorMessageTranslated = (key, language = 'es') => {
  return key.split('.').reduce((obj, segment) => obj?.[segment], translations[language]) || 'Mensaje no encontrado'
}